import React, { useEffect, useState } from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const CustomDropdown = ({
  title,
  setFilterOption,
  filterOption,
  performanceDropdownOptions,
  isYearlyDropdown,
}) => {
  const [sortDropdown, setSortDropdown] = React.useState({
    opened: false,
    activeOption: 0,
  })

  const toggleSortDropdown = () => {
    setSortDropdown((previousState) => {
      return { ...previousState, opened: !previousState.opened }
    })
  }

  const onBlur = () => {
    debugger
    setSortDropdown((previousState) => {
      return { ...previousState, opened: false }
    })
  }

  const [options, setOptions] = useState([])
  useEffect(() => {
    if (isYearlyDropdown === false) {
      setOptions([
        { label: 'For How Long?', value: null },
        { label: '1 Month', value: 1 },
        { label: '3 Months', value: 3 },
        { label: '6 months', value: 6 },
        { label: '1 Year', value: 12 },
        { label: 'All Time', value: null },
      ])
    } else {
      setOptions([
        { label: 'For How Long?', value: null },
        {
          label: `${new Date().getFullYear()}`,
          value: new Date().getFullYear(),
        },
        {
          label: `${new Date().getFullYear() - 1}`,
          value: new Date().getFullYear() - 1,
        },
        {
          label: `${new Date().getFullYear() - 2}`,
          value: new Date().getFullYear() - 2,
        },
        {
          label: `${new Date().getFullYear() - 3}`,
          value: new Date().getFullYear() - 3,
        },
        {
          label: `${new Date().getFullYear() - 4}`,
          value: new Date().getFullYear() - 4,
        },
        { label: 'All Time', value: null },
      ])
    }
  }, [])

  return (
    <div className="row">
      <div className="col-12 text-right">
        <div
          onClick={toggleSortDropdown}
          onBlur={onBlur}
          className="position-relative pointer mt-3 mt-sm-3 mt-md-0 float-end"
        >
          <div className="sort-dropdown d-flex flex-wrap justify-content-between align-items-center">
            <p className="fs-12 m-0 fw-bold">{title}</p>
            <p className="fs-12 m-0 color-primary fw-bold">
              {filterOption?.label ?? (!isYearlyDropdown ? 'Months' : 'Year')}
              <span>
                <KeyboardArrowDownIcon />
              </span>
            </p>
          </div>
          {sortDropdown.opened && (
            <div className="dropdown-content">
              {options.map((item, index) => (
                <div
                  key={index}
                  className={`dropdown-option hover-div ${
                    sortDropdown.activeOption === index
                      ? 'active-dropdown-option'
                      : ''
                  }`}
                  onClick={() => {
                    if (index > 0) {
                      setSortDropdown((prev) => ({
                        ...prev,
                        opened: true,
                        activeOption: index,
                      }))
                      setFilterOption(item)
                    }
                  }}
                >
                  <p className="fs-12">{item.label}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CustomDropdown
